





















































import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import { PlayCircleStrokeIcon } from 'tdesign-icons-vue';

import i18n, { i18n_t } from '@/locales/i18n';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { httpUrl } from '@/renderer/scripts/http';
import { IS_BROWSER } from '@/common/constant/platform';

export default defineComponent({
  name: 'StepForm3',
  components: {
    PlayCircleStrokeIcon,
  },
  setup() {
    const createTeamItem = {
      title: i18n_t('模板批量导入成员'),
      info: i18n_t('填写成员信息模板，一键批量导入'),
    };
    const methods = {
      clickHandler(step: 'one' | 'two') {
        const tjdMap = {
          one: 'step_three_member_list',
          two: 'step_three_idaas',
        };
        reporter.report('manager_new_guide_success', {
          success_count_type: tjdMap[step],
        });
        const videoNum = step === 'one' ? '001' : '002';
        if (IS_BROWSER) {
          dispatchRouter(
            `${httpUrl.staticCDNUrl}/tools/videos/guide_${videoNum}.mp4`,
            'newWindow',
            'height=500,width=700,top=200,left=300',
          );
        } else {
          dispatchRouter(`${httpUrl.staticCDNUrl}/tools/videos/guide_${videoNum}.mp4`);
        }
      },
    };
    return {
      createTeamItem,
      ...methods,
    };
  },
});
